import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
const DEFAULT_SWIPER_CONFIG = {
    direction: 'horizontal',
    slidesPerView: 'auto',
    keyboard: true,
};
const ɵ0 = DEFAULT_SWIPER_CONFIG;
export class AppCommonModule {
}
export { ɵ0 };
